import type { JSX } from "react";

// @workaround, could be imported as .svg ReactComponent with svgr plugin.
export function Zeller(props: JSX.IntrinsicElements["svg"]) {
	return (
		<svg
			width="69"
			height="24"
			viewBox="0 0 69 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-label="Zeller"
			{...props}
		>
			<g clipPath="url(#clip0_859_10776)">
				<path d="M31.5874 0H34.6492V19.3959H31.5874V0Z" fill="currentColor" />
				<path
					d="M0.400391 10.0768V7.01496H12.7129V9.24653L4.97444 18.4299H12.7129V21.4917H0.400391V19.2622L8.14403 10.0768H0.400391Z"
					fill="currentColor"
				/>
				<path
					d="M40.1852 4.6041H37.1234V24H40.1852V4.6041Z"
					fill="currentColor"
				/>
				<path
					d="M63.1217 8.68066C64.4091 7.32182 66.0364 6.68645 68.0979 6.74035L68.6017 6.75175V9.85708L68.0803 9.84983C67.2511 9.85086 64.4443 10.0582 63.1217 12.6815V21.4928H60.0599V7.01502H63.1217V8.68066Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M26.3044 17.2006C25.1146 18.291 23.7754 18.8207 22.2093 18.8207C19.8025 18.8207 18.1949 17.7386 17.6591 15.7671H28.6625L28.7102 15.2935C28.9631 12.78 28.3463 10.536 26.972 8.97501C25.7033 7.53325 23.8407 6.73929 21.7283 6.73929C17.5264 6.73929 14.476 9.88712 14.476 14.2259C14.476 18.5646 17.6052 21.7664 22.2621 21.7664C24.4056 21.7664 26.1842 21.1009 27.8592 19.6727L28.1826 19.3959L26.6351 16.8969L26.3034 17.1996L26.3044 17.2006ZM21.7283 9.68708C23.8614 9.68708 25.2928 10.8666 25.6815 12.9323H17.6072C18.0654 10.8956 19.5921 9.68708 21.7273 9.68708H21.7283Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M50.7398 18.8207C52.3059 18.8207 53.6451 18.291 54.835 17.2006L54.8339 17.1996L55.1656 16.8969L56.7131 19.3959L56.3897 19.6727C54.7147 21.1009 52.9361 21.7664 50.7926 21.7664C46.1357 21.7664 43.0065 18.5646 43.0065 14.2259C43.0065 9.88712 46.0569 6.73929 50.2588 6.73929C52.3712 6.73929 54.2338 7.53325 55.5025 8.97501C56.8768 10.536 57.4936 12.78 57.2407 15.2935L57.193 15.7671H46.1896C46.7254 17.7386 48.333 18.8207 50.7398 18.8207ZM54.212 12.9323C53.8233 10.8666 52.3919 9.68708 50.2588 9.68708H50.2578C48.1226 9.68708 46.5959 10.8956 46.1377 12.9323H54.212Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_859_10776">
					<rect width="69" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
